export const alterModal = () => {
    return {
        type: 'ALTER-MODAL'
    };
};

